<template>
  <dp-draft-create :subNavTitle="title" :capsule="capsule" :saveMessage="saveMessage"></dp-draft-create>
</template>

<script>
  import CreateTemplate from '../../requests/creationPages/DDCreateTemplate.vue'
  export default {
    name: 'Capsule-Draft-Create',
    data: () => {
      return {
        title: 'Modular Loan - Create Draft',
        capsule: 'draft-create',
        saveMessage: 'Draft added'
      }
    },
    components: {
      'dp-draft-create': CreateTemplate
    }
  }
</script>



// WEBPACK FOOTER //
// TDraftCreate.vue?02ea0b31